"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var ra_fetch_1 = require("ra-fetch");
var storybook_1 = require("@eyecons/storybook");
var prop_types_1 = __importDefault(require("prop-types"));
function Pro(_a) {
    var user = _a.user, status = _a.status;
    var _b = storybook_1.Hooks.useModal(), Modal = _b[0], setModal = _b[1];
    var plans = ra_fetch_1.useApi('ecommerce').index('plans', { type: 'channels' })[0];
    if (plans.loading) {
        return react_1.default.createElement(storybook_1.Icons.Icon, { name: 'loader' });
    }
    return react_1.default.createElement("div", { className: storybook_1.Helpers.classNames('bg-white', user.id ? '' : 'subscriptions-with-warning') },
        react_1.default.createElement(Modal, null),
        react_1.default.createElement(storybook_1.Subscriptions.Hero, null),
        react_1.default.createElement(storybook_1.Subscriptions.Plans, { plans: plans, user: user, setModal: setModal, status: status }),
        react_1.default.createElement("div", { className: 'storybook-subscriptions-plans' }),
        react_1.default.createElement(storybook_1.Subscriptions.ContentBlocks, null));
}
Pro.propTypes = {
    /**
     * Current user session
     */
    user: prop_types_1.default.shape({
        id: prop_types_1.default.number,
    }),
    status: prop_types_1.default.string
};
Pro.defaultProps = {
    user: {},
};
exports.default = Pro;
